.root {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  margin-block-end: var(--space-4);
}

.title {
  font: var(--type-title-lg);
  letter-spacing: var(--tracking-title-lg);
  margin: 0;
  color: var(--md-on-surface);
}

.count {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  color: var(--md-on-surface-variant);
  font-weight: 600;
}

.actions {
  margin-inline-start: auto;
  display: flex;
  align-items: center;
  gap: var(--space-2);
}
